import script from "./ReportAndCAPAIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportAndCAPAIndex.vue?vue&type=script&setup=true&lang=js"

import "./ReportAndCAPAIndex.vue?vue&type=style&index=0&id=4eaccabe&lang=css"
import "./ReportAndCAPAIndex.vue?vue&type=style&index=1&id=4eaccabe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eaccabe"]])

export default __exports__